<template>
  <v-text-field
    :prepend-icon="schema.icon"
    type="email"
    :name="name"
    :label="schema.label || schema.editableLabel || name"
    :value="value"
    :required="!schema.optional"
    :rules="emailRules"
    :error-messages="errorMessages"
    :disabled="disabled"
    @input="handleInput"
    :solo="schema.solo"
  />
</template>
<script>
export default {
  name: 'string',
  props: {
    /** Current Value */
    value: { type: String, default: '' },
    /** Validation Errors */
    errorMessages: { type: String },
    /** Field Name */
    name: { type: String, required: true },
    /** Field Schema */
    schema: { type: Object, default: () => ({}) },
    /** Disabled state */
    disabled: { type: Boolean, default: false }
  },
  data () {
    return {
      emailRules: [
        v => !!v || 'El correo es obligatorio',
        v => /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i.test(v) || 'Correo invalido'
      ]
    }
  },
  methods: {
  /** Validation Rules */
  /* validationRules () {
    const rules = [] */
  // Required validation
    /* if (!this.schema.optional) {
      rules.push((v) => !!v || 'Campo requerido.')
    } */
    // Email Validation
    /* rules.push((v) => !v || /.+@.+/.test(v) || 'E-mail inválido')
    return rules
  }, */
    /** Additional field options */
    /* fieldOptions () {
    return this.schema.fieldOptions || {}
  }, */
    /** Input event handler */
    handleInput (...args) {
      this.$emit('input', ...args)
    }
  }
}
</script>
